// extracted by mini-css-extract-plugin
export default {"groupCardPicture":"groups_groupCardPicture__p6AKY","miniCardText":"groups_miniCardText__qpbJZ","cardGroupName":"groups_cardGroupName__qP-on"};